<button
  type="button"
  class="sz-action-menu__trigger"
  [class.sz-action-menu__trigger--active]="open()"
  (click)="toggle()"
  aria-haspopup="menu"
  [attr.aria-expanded]="open()"
  [attr.aria-label]="ariaLabel()">
  <sz-icon name="dots-vertical" [size]="18" />
</button>

@if (open()) {
  <div class="sz-action-menu__backdrop" [class.sz-action-menu__backdrop--blur]="blurBackdrop()" (click)="close()"></div>
  <div class="sz-action-menu__panel" role="menu">
    @for (item of items(); track item.id) {
      <button
        type="button"
        class="sz-action-menu__item"
        [class.sz-action-menu__item--destructive]="item.destructive"
        role="menuitem"
        (click)="onSelect(item.id)">
        <sz-icon [name]="item.icon" [size]="14" />
        <span class="sz-action-menu__item-label">{{ item.label }}</span>
      </button>
    }
  </div>
}
